import { HttpClient, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "./../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BaseApiService {
  protected http = inject(HttpClient);

  private _rootUrl = "";

  /**
   * Returns the root url for all operations in this service. If not set directly in this
   * service, will fallback to `ApiConfiguration.rootUrl`.
   */
  get rootUrl(): string {
    return this._rootUrl || environment.apiUri;
  }

  /**
   * Sets the root URL for API operations in this service.
   */
  set rootUrl(rootUrl: string) {
    this._rootUrl = rootUrl;
  }
}

@Injectable({
  providedIn: "root",
})
export class AuthInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler) {
    // Clone the request and replace the original headers with
    // cloned headers, updated with the subscription key.
    const authReq = req.clone({
      headers: req.headers.set("Ocp-Apim-Subscription-Key", environment.apimSubscriptionKey),
    });
    return next.handle(authReq);
  }
}
